import { DateTime } from "luxon";

function convertDate(date: any, dateFormat: any, timeZone?: any) {
  if (!date || isNaN(Number(date))) {
    return "";
  }
  const time = DateTime.fromMillis(Number(date));

  const formatMap = {
    dateForText: () => `${time.toFormat("MMM dd")} at ${time.toFormat("hh:mm a")}`,
    dateForTooltip: () => `${time.toFormat("MMM dd,yyyy")} at ${time.toFormat("hh:mm:ss a")}`,
    dateForProfile: () => time.toFormat("MMM dd, yyyy"),
    dateForOrganization: () => time.toFormat("MMM dd, yyyy"),
    NormalDate: () => time.toFormat("dd/MM/yyyy"),
    NormalDateTime: () => time.toFormat("MM/dd/yyyy hh:mm a"),
    getDifferenceTime: () => time.toRelative(),
    dateForToolTipModal: () => time.toFormat("MMM dd, yyyy"),
    dateForTooltipSpaceBeforeYear: () => `${time.toFormat("MMM dd, yyyy")} at ${time.toFormat("hh:mm:ss a")}`,
    dateForSignHistory: () => time.toFormat("MMM dd hh:mm a"),
    standardIsoFormat: () => time.toISO(),
    dateForPdfExport: () => `${time.toFormat("MMM dd, yyyy")} at ${time.toFormat("hh:mm a")}`,
    dateForSchedule: () => {
      const timeWithTimezone = time.setZone(timeZone);
      return `${timeWithTimezone.toFormat("MMM dd, yyyy")} at ${timeWithTimezone.toFormat("hh:mm a")}`;
    },
    dateForPortalDashboard: () => ({
      date: time.toFormat("dd MMM yy"),
      day: time.toFormat("cccc"),
      time: time.toFormat("hh:mm:ss a"),
      timeZone: time.toFormat("ZZ"),
    }),
    dateforProjectDashbaord: () => `${time.toFormat("dd MMM, yy")} ${time.toFormat("hh:mm a")}`,
    chatBot: () => `At ${time.toFormat("hh:mm a")}`,
  };

  const defaultFormat = () => time.toFormat(dateFormat);
  const formatter = formatMap[dateFormat] || defaultFormat;

  return formatter();
}

export { convertDate };
